module.exports = __webpack_public_path__ + "media/images/emblems/Celigny-coat_of_arms-3c3ff6c471dd65572091ab6d156bc7b8.svg";